import { Component, ViewChild } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { Globals } from "../../../globals";
import { IngredientsServices } from "../../ingredients/services";
import { ProductsServices } from "../../products/services";
import { StockServices } from "../services";
import { IngredientViewPage } from "../../ingredients/ingredient-view/ingredient-view/ingredient-view";
import { ProvidersServices } from "../../providers/services";
import { DeliberyNoteCreateSelectProviderPage } from "../../delibery_note/delibery-note-create/delibery-note-create-select-provider/delibery-note-create-select-provider";
import { ProvidersCreateDataPage } from "../../providers/providers-create/providers-create-data/providers-create-data";
import { ProviderOrderAddPage } from '../../providers/orders/provider-order-add/provider-order-add';
import { TranslateService } from '@ngx-translate/core';
import { StockListUpdateInventoryPage } from '../stock-list-update-inventory/stock-list-update-inventory';
import { IngredientCreateSelectType } from '../../ingredients/ingredient-create-select-type/ingredient-create-select-type';
import { ProductCreateSelectTypePage } from '../../products/product-create/product-create-select-type/product-create-select-type';
import { ImportExcelPage } from '../../components/import-excel/import-excel';
import { AddonsTriggerVersionProPage } from '../../addons/addons-trigger-version-pro/addons-trigger-version-pro';
import { HttpClient, HttpParams } from '@angular/common/http';
import { TutorialStockPage } from '../../help/tutorials/tutorial-stock/tutorial-stock';
import { ColumnMode, DatatableComponent } from '@swimlane/ngx-datatable';
import { DeliberyNoteCreateFotoPage } from '../../delibery_note/delibery-note-create/delibery-note-create-foto/delibery-note-create-foto';
import { ArticleViewPage } from '../../articles/articles-view/article-view';
import { AnalyticsServices } from '../../services/analyticsServices';
import { ProviderOrderCartPage } from '../../providers/orders/provider-order-cart/provider-order-cart';
import { IngredientCreateInfoPage } from '../../ingredients/ingredient-create/ingredient-create-info/ingredient-create-info';
import { DeliberyNoteCreateTypePage } from '../../delibery_note/delibery-note-create/delibery-note-create-type/delibery-note-create-type';
import { StockMovementsPage } from '../../analytics/reports/stock-movements/stock-movements';

/**
 * Generated class for the StockListPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-stock-list',
  templateUrl: 'stock-list.html',
})
export class StockListPage {

  ingredient_list: boolean = true;
  searchbar_text: string = '';
  show_tutorial: boolean = false;
  license_access: boolean = true;
  //datatable
  sorts = [
    { prop: 'name', dir: 'asc' },
    { prop: 'stock', dir: 'asc' },
    { prop: 'price', dir: 'asc' },
    { prop: 'min', dir: 'asc' },
    { prop: 'max', dir: 'asc' },
    { prop: 'state', dir: 'asc' }
  ];
  @ViewChild(DatatableComponent) table: DatatableComponent;
  ColumnMode = ColumnMode;
  config_msg = {
    emptyMessage: this.translate.instant('general-no-hay-datos'),
    totalMessage: this.translate.instant('general-total'),
    selectedMessage: this.translate.instant('general-seleccionado')
  };

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public ingredientServices: IngredientsServices,
    public productsServices: ProductsServices,
    public providersServices: ProvidersServices,
    public stockServices: StockServices,
    public globals: Globals,
    public translate: TranslateService,
    public http: HttpClient,
    public analyticsServices: AnalyticsServices) {
    this.stockServices.ingprod_searchbar_text = '';
    this.stockServices.ingprod_array_filtered = this.stockServices.ingprod_array_tmp;
    this.globals.GAtrackView('Stock', 'Stock - List', this.globals.restaurant.email, 'View', 'List stock', 'Stock', '');

    //Tutorial Stock
    if (this.globals.restaurant.license == 'free') {
      this.show_tutorial = true;
      this.navCtrl.push(TutorialStockPage);
    }
  }

  async ionViewWillEnter() {
    this.changePLG();
    
    //Get ingredients and products
    // Los arrays se limpian automáticamente en getIngProd()
    this.stockServices.getIngProd(false);

    this.stockServices.page_active = 1;
    if (this.globals.checkLimitsByLicense('stock', 'analitycs')) {//version pro abierto
      //Get analitics
      this.getAnalitca();
    } else {
      //paramos los loadres
      this.loader_stock_value = true;
      this.loader_categories = true;
      this.loader_providers = true;
      this.loader_stock_spoiled_food = true;
    }
    //GET TAGS
    await this.getTags();
    //this.filter(this.searchbar_text);
    this.checkLicenseAccess();
  }

  async checkLicenseAccess() {
    let limit = this.globals.checkLimitsByLicense('stock', 'ings_prods')
    if (limit >= 0) {
      const params = new HttpParams()
        .set('uid', this.globals.restaurant_uid)
        .set('elements_per_page', limit)
        .set('limit', limit);
      await this.http.post(this.globals.analytics_path + 'paginate/limited_products', params, {})
        .subscribe(async res => {
          if (res['list'].length >= limit) {
            this.license_access = false;
          }
        });
    }
  }

  /*OPEN*/
  openElementView(element) {
    if (element._active) {
      if (element.type == 'ingredient') {
        this.navCtrl.push(IngredientViewPage, {
          ingredient_uid: element.UID,
          ingredient_name: this.globals.nameLangSelectIngredient(element),
        });
      } else {
        this.navCtrl.push(ArticleViewPage, {
          article_type: 'product',
          article_uid: element.UID
        });
      }
    } else {
      this.navCtrl.push(AddonsTriggerVersionProPage);
    }
  }

  /*CREATE*/
  createProduct() {
    if (this.license_access) {
      this.productsServices.show_alert_delete = true;
      this.navCtrl.push(ProductCreateSelectTypePage);
    } else {
      this.navCtrl.push(AddonsTriggerVersionProPage);
    }
  }

  createIngredient() {
    if (this.globals.checkLimitsByLicense('stock', 'ings')) {
      this.ingredientServices.show_alert_delete = true;
      if (this.globals.restaurant.plg_stock_starter === undefined || this.globals.restaurant.plg_stock_starter === false) {
        this.navCtrl.push(IngredientCreateInfoPage);
      } else {
        this.navCtrl.push(IngredientCreateSelectType);
      }
    } else {
      this.navCtrl.push(AddonsTriggerVersionProPage);
    }
  }

  createDeliberyNote() {
    if (this.globals.checkLimitsByLicense('stock', 'delivery_notes')) {
      this.navCtrl.push(DeliberyNoteCreateSelectProviderPage);
    } else {
      this.navCtrl.push(AddonsTriggerVersionProPage);
    }
  }

  createProvider() {
    this.navCtrl.push(ProvidersCreateDataPage);
  }

  openProviderOrderAdd(element, type) {
    this.navCtrl.push(ProviderOrderAddPage, {
      element: element,
      type: type
    });
  }



  updateInventory() {
    if (this.globals.checkLimitsByLicense('stock', 'update_inventory')) {//version pro abierto
      this.navCtrl.push(StockListUpdateInventoryPage);
    } else {
      this.navCtrl.push(AddonsTriggerVersionProPage);
    }
  }

  async getTags() {
    // Los tags ya se cargan al inicio de la app en getAllTags()
    // No es necesario cargarlos aquí
  }

  importProduct(type) {
    this.navCtrl.push(ImportExcelPage, {
      type: type
    });
  }

  importIngredient(type) {
    this.navCtrl.push(ImportExcelPage, {
      type: type
    });
  }

  /***********************************************************/
  /*                        ANALITCA                        */
  /***********************************************************/

  getAnalitca() {
    this.getTotalValueStock();
    this.getTotalStockTags();
    this.getTotalStockProviders();
    this.getTotalStockSpoiledFood();
  }

  public total_value_stock: any;
  public loader_stock_value: boolean = false;
  getTotalValueStock() {
    //Funcion que pide el valor total del stock
    this.loader_stock_value = false;
    const params = new HttpParams()
      .set('public_key', this.globals.public_key);

    this.http.post(this.globals.analytics_path + 'bistock/stock_value_store', params, {})
      .subscribe(res => {
        this.total_value_stock = res;
        this.loader_stock_value = true;
      });
  }

  public loader_categories: boolean = false;
  public total_value_stock_tags: any;
  public total_value_stock_5_tags: any;
  public total_elements_tags: any;
  public total_elements_without_tags: any;
  getTotalStockTags() {
    //Funcion que pide el valor total del stock de cada categoria/tag
    this.loader_categories = false;
    const params = new HttpParams()
      .set('public_key', this.globals.public_key);

    this.http.post(this.globals.analytics_path + 'bistock/stock_tags', params, {})
      .subscribe(res => {
        this.total_value_stock_tags = res['all_tags'];
        this.total_value_stock_5_tags = res['five_tags'];
        this.total_elements_tags = res['total_elements_tags'];
        this.total_elements_without_tags = res['total_elements_without_tags'];
        this.loader_categories = true;
      });
  }

  public loader_providers: boolean = false;
  public total_value_stock_providers: any;
  public total_value_stock_5_providers: any;
  getTotalStockProviders() {
    //Funcion que pide el valor total del stock de cada proveedor
    this.loader_providers = false;
    const params = new HttpParams()
      .set('public_key', this.globals.public_key);

    this.http.post(this.globals.analytics_path + 'bistock/stock_providers', params, {})
      .subscribe(res => {
        this.total_value_stock_providers = res['all_providers'];
        this.total_value_stock_5_providers = res['five_providers'];
        this.loader_providers = true;
      });
  }

  //Funció per a mostrar més categories
  public show_all_categories = false;
  change_show_categories() {
    if (this.show_all_categories) {
      this.show_all_categories = false;
    } else {
      this.show_all_categories = true;
    }
  }

  //Funció per a mostrar més proveeidors
  public show_all_providers = false;
  change_show_providers() {
    if (this.show_all_providers) {
      this.show_all_providers = false;
    } else {
      this.show_all_providers = true;
    }
  }

  //Al clicar un tag, buscar en buscador
  searchTagProvider(tag) {
    this.stockServices.ingprod_searchbar_text = tag;
    this.stockServices.ingprodSearch(this.stockServices.ingprod_searchbar_text);
  }

  styleIcon(total, quantity) {
    let styles = {
      'width': this.globals.regla3(total, quantity) + '%',
    };
    return styles;
  }

  public total_stock_spoiled_food: any;
  public loader_stock_spoiled_food: boolean = false;
  getTotalStockSpoiledFood() {
    //Funcion que pide el valor total del stock
    this.loader_stock_spoiled_food = false;
    const params = new HttpParams()
      .set('public_key', this.globals.public_key);

    this.http.post(this.globals.analytics_path + 'bistock/stock_spoiled_food', params, {})
      .subscribe(res => {
        this.total_stock_spoiled_food = res['elements_spoiled'];
        this.loader_stock_spoiled_food = true;
      });
  }

  clickElement(event) {
    if (event.type == 'click') {
      if (event.column.name == 'cesta') {
        if (event.row.sub_recipe) {
          this.openProviderOrderAdd(event.row, event.row.type + '-comp');
        } else {
          this.openProviderOrderAdd(event.row, event.row.type);
        }
      } else {
        this.openElementView(event.row);
      }
    }
  }

  onSort(event) {

    var elements_array = this.stockServices.ingprod_array_filtered;

    switch (event.column.name) {
      case 'name':
        if (event.newValue == 'asc') {
          elements_array.sort((a, b) => this.globals.getNameIngProd(a).localeCompare(this.globals.getNameIngProd(b)));
        } else {
          elements_array.sort((a, b) => this.globals.getNameIngProd(b).localeCompare(this.globals.getNameIngProd(a)));
        }
        break;
      case 'stock':
        if (event.newValue == 'asc') {
          elements_array.sort((a, b) => a.stock - b.stock);
        } else {
          elements_array.sort((a, b) => b.stock - a.stock);
        }
        break;
      case 'price':
        if (event.newValue == 'asc') {
          elements_array.sort((a, b) => a.price_static - b.price_static);
        } else {
          elements_array.sort((a, b) => b.price_static - a.price_static);
        }
        break;
      case 'min':
        if (event.newValue == 'asc') {
          elements_array.sort((a, b) => a.stock_alert - b.stock_alert);
        } else {
          elements_array.sort((a, b) => b.stock_alert - a.stock_alert);
        }
        break;
      case 'max':
        if (event.newValue == 'asc') {
          elements_array.sort((a, b) => a.stock_max - b.stock_max);
        } else {
          elements_array.sort((a, b) => b.stock_max - a.stock_max);
        }
        break;
      case 'state':
        if (event.newValue == 'asc') {
          elements_array.sort((a, b) => {
            const getStatusOrder = (row) => {
              if (row.stock_max == 0) return 1; // Nulo
              if (row.stock < row.stock_alert) return 0; // Por debajo
              if (row.stock >= row.stock_alert && row.stock <= row.stock_max) return 2; // Equilibrado
              if (row.stock > row.stock_max) return 3; // Por encima
            };
            return getStatusOrder(a) - getStatusOrder(b);
          });
        } else {
          elements_array.sort((a, b) => {
            const getStatusOrder = (row) => {
              if (row.stock_max == 0) return 1; // Nulo
              if (row.stock < row.stock_alert) return 0; // Por debajo
              if (row.stock >= row.stock_alert && row.stock <= row.stock_max) return 2; // Equilibrado
              if (row.stock > row.stock_max) return 3; // Por encima
            };
            return getStatusOrder(b) - getStatusOrder(a);
          });
        }
        break;
    }

    this.stockServices.ingprod_array_filtered = elements_array;
  }

  getRowClass(row) {
    return {
      'not-active': row._active === false,
    };
  }

  openDenoIA() {
    if (this.globals.checkLimitsByLicense('stock', 'delivery_notes')) {
      this.navCtrl.push(DeliberyNoteCreateFotoPage);
    } else {
      this.navCtrl.push(AddonsTriggerVersionProPage);
    }
  }

  openNewDeno() {
    this.navCtrl.push(DeliberyNoteCreateTypePage);
  }

  openDeliberyNoteCreate() {
    if (this.globals.checkLimitsByLicense('stock', 'delivery_notes')) {
      this.navCtrl.push(DeliberyNoteCreateTypePage);
    } else {
      this.navCtrl.push(AddonsTriggerVersionProPage);
    }
  }

  changePLG() {
    if (this.globals.restaurant.plg_stock_starter === undefined || this.globals.restaurant.plg_stock_starter === false) {
      //save plg_stock_starter true
      this.stockServices.afs.collection('restaurants').doc(this.globals.restaurant_uid).update({
        plg_stock_starter: true
      });
      this.globals.restaurant.plg_stock_starter = true;
      this.analyticsServices.trackingExpStock('starter', this.globals.tracking_exp['starter'], '');
      this.globals.updateERPNextCustomer();
    }
  }

  openCart() {
    if (this.globals.checkLimitsByLicense('stock', 'pedidos')) {
      this.providersServices.getTotalCartElements(this.globals.restaurant_uid, this.globals.user_uid);
      this.navCtrl.push(ProviderOrderCartPage);
    } else {
      this.navCtrl.push(AddonsTriggerVersionProPage);
    }
    this.globals.open_side_menu = false;
  }

  openLanding() {
    if (this.globals.so_mobile) {
      window.location.assign('https://landing.mycheftool.com/es/stock');
    } else {
      window.open('https://landing.mycheftool.com/es/stock', '_blank');
    }
  }

  stateColCss() {
    if (this.globals.platform_width === 'mobile') {
      let cssClasses = {
        'col-6': true
      }
      return cssClasses;
    } else {
      let cssClasses = {
        'col-auto': true
      }
      return cssClasses;
    }
  }

  changeValue(type) {
    if (type == 'products') {
      this.stockServices.show_products = !this.stockServices.show_products;
    } else {
      this.stockServices.show_ingredients = !this.stockServices.show_ingredients;
    }
    this.stockServices.filter();
  }

  openStockMovements() {
    if (this.globals.checkLimitsByLicense('stock', 'analitycs')) {
      this.navCtrl.push(StockMovementsPage);
    }
  }
}


// WEBPACK FOOTER //
// ./src/pages/stock/stock-list/stock-list.ts